import { useHistory } from 'react-router-dom'

export const useLink = () => {
  const history = useHistory()

  return (route, params = {}) => () => {
    history.push(route, params)
  }
}
